var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerFlowChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 107.836,
    y1: 111.636,
    x2: 107.836,
    y2: 190.271,
    id: "gradient-0",
    gradientTransform: "matrix(0.49618, 0.915073, -1.779134, 0.774558, 462.536499, -175.279648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(74, 126, 159)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(52, 91, 130)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 107.836,
    y1: 111.636,
    x2: 107.836,
    y2: 190.271,
    id: "gradient-3",
    gradientTransform: "matrix(0.496158, 0.915073, -1.779056, 0.774558, 642.541748, -58.323112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(74, 126, 159)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(52, 91, 130)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 107.836,
    y1: 111.636,
    x2: 107.836,
    y2: 190.271,
    id: "gradient-1",
    gradientTransform: "matrix(0.496159, 0.915072, -1.779055, 0.774556, 308.510864, -56.140827)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(74, 126, 159)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(52, 91, 130)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 310.028 36.598 L 348.832 36.598 L 348.832 33.119 L 360.028 38.916 L 348.832 44.713 L 348.832 41.235 L 310.028 41.235 L 310.028 36.598 Z",
    style: {
      strokeDasharray: 2,
      fill: "rgb(56, 97, 135)"
    },
    transform: "matrix(1, -0.000062, 0.000062, 1, -0.002412, 0.020772)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 130.141 37.791 L 168.945 37.791 L 168.945 34.312 L 180.141 40.109 L 168.945 45.906 L 168.945 42.428 L 130.141 42.428 L 130.141 37.791 Z",
    style: {
      strokeDasharray: 2,
      fill: "rgb(56, 97, 135)"
    },
    transform: "matrix(1, -0.000062, 0.000062, 1, -0.002486, 0.009619)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12.500497, -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#gradient-0)"
    },
    x: 167.294,
    y: 0.904,
    width: 140.006,
    height: 80,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "battery-blue",
    d: "M 225.286 27.275 L 222.156 27.275 L 222.156 22.585 C 222.156 21.724 221.457 21.025 220.596 21.025 L 211.216 21.025 C 210.354 21.025 209.656 21.724 209.656 22.585 L 209.656 22.585 L 209.656 27.275 L 197.155 27.275 L 197.155 22.585 C 197.155 21.724 196.456 21.025 195.595 21.025 L 186.215 21.025 C 185.353 21.025 184.655 21.724 184.655 22.585 L 184.655 22.585 L 184.655 27.275 L 181.524 27.275 C 179.799 27.281 178.404 28.68 178.404 30.405 L 178.404 55.405 C 178.404 57.128 179.801 58.525 181.524 58.525 L 225.286 58.525 C 227.009 58.525 228.406 57.128 228.406 55.405 L 228.406 30.405 C 228.406 28.68 227.011 27.281 225.286 27.275 Z M 197.155 40.555 C 197.155 40.986 196.806 41.335 196.375 41.335 L 185.405 41.335 C 184.974 41.335 184.625 40.986 184.625 40.555 L 184.625 40.555 L 184.625 39.025 C 184.608 38.583 184.962 38.215 185.405 38.215 L 196.405 38.215 C 196.836 38.215 197.185 38.564 197.185 38.995 L 197.185 38.995 Z M 222.156 40.555 C 222.156 40.986 221.807 41.335 221.376 41.335 L 217.466 41.335 L 217.466 45.245 C 217.466 45.676 217.117 46.025 216.686 46.025 L 215.126 46.025 C 214.695 46.025 214.346 45.676 214.346 45.245 L 214.346 45.245 L 214.346 41.335 L 210.406 41.335 C 209.975 41.335 209.626 40.986 209.626 40.555 L 209.626 40.555 L 209.626 39.025 C 209.626 38.594 209.975 38.245 210.406 38.245 L 214.316 38.245 L 214.316 34.305 C 214.316 33.874 214.665 33.525 215.096 33.525 L 216.656 33.525 C 217.087 33.525 217.436 33.874 217.436 34.305 L 217.436 34.305 L 217.436 38.215 L 221.406 38.215 C 221.837 38.215 222.186 38.564 222.186 38.995 L 222.186 38.995 Z",
    style: {
      stroke: "rgb(186, 218, 85)",
      strokeWidth: 0,
      paintOrder: "stroke",
      fill: "rgb(246, 248, 250)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12.587011, -117.861)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#gradient-3)"
    },
    x: 347.313,
    y: 117.861,
    width: 140,
    height: 80,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.669943, 0, -0.027087, 0.669943, 125.629868, -128.830658)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "load-blue-1",
    d: "M 400.667 398.54 C 400.667 395.33 397.192 393.324 394.412 394.929 C 393.122 395.674 392.327 397.051 392.327 398.54 L 392.327 411.04 L 400.667 411.04 Z",
    style: {
      fill: "rgb(247, 249, 251)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "load-blue-2",
    d: "M 375.667 398.54 C 375.667 395.33 372.192 393.324 369.412 394.929 C 368.122 395.674 367.327 397.051 367.327 398.54 L 367.327 411.04 L 375.667 411.04 Z",
    style: {
      fill: "rgb(247, 249, 251)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "load-blue-3",
    points: "377.257 426.09 377.237 426.09 376.777 427.64 375.987 430.21 378.487 430.21 377.717 427.64 377.257 426.09",
    style: {
      fill: "rgb(247, 249, 251)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "load-blue-4",
    d: "M 406.917 415.2 L 361.077 415.2 C 359.927 415.206 358.997 416.14 358.997 417.29 L 358.997 421.45 C 358.997 422.601 359.927 423.535 361.077 423.54 L 363.167 423.54 L 363.167 427.7 C 363.165 437.6 370.129 446.135 379.827 448.12 L 379.827 461.04 L 388.167 461.04 L 388.167 448.12 C 397.866 446.135 404.829 437.6 404.827 427.7 L 404.827 423.54 L 406.917 423.54 C 408.067 423.535 408.997 422.601 408.997 421.45 L 408.997 417.29 C 408.997 416.14 408.067 415.206 406.917 415.2 Z",
    style: {
      fill: "rgb(247, 249, 251)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13, -120.139)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#gradient-1)"
    },
    x: 13.282,
    y: 120.043,
    width: 140,
    height: 80,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "solar-blue",
    d: "M 51.905 175.974 L 48.155 175.974 L 48.155 173.474 L 38.155 173.474 L 38.155 175.974 L 34.405 175.974 C 33.707 175.974 33.144 176.546 33.155 177.244 L 33.155 177.244 L 33.155 179.724 C 33.155 180.414 33.715 180.974 34.405 180.974 L 34.405 180.974 L 51.905 180.974 C 52.603 180.974 53.166 180.402 53.155 179.704 L 53.155 179.704 L 53.155 177.224 C 53.155 176.533 52.595 175.974 51.905 175.974 Z M 63.905 143.054 C 63.684 141.831 62.608 140.949 61.365 140.974 L 24.945 140.974 C 23.71 140.965 22.65 141.848 22.435 143.064 C 17.895 169.814 18.155 168.164 18.155 168.474 C 18.177 169.865 19.314 170.979 20.705 170.974 L 65.605 170.974 C 66.991 170.985 68.128 169.879 68.155 168.494 C 68.155 168.174 68.415 169.814 63.875 143.064 Z M 38.455 145.974 L 47.855 145.974 L 48.615 153.474 L 37.695 153.474 Z M 32.585 165.974 L 23.705 165.974 L 25.155 157.224 L 33.435 157.224 Z M 33.855 153.474 L 25.855 153.474 L 27.155 145.974 L 34.665 145.974 Z M 36.415 165.974 L 37.305 157.224 L 49.005 157.224 L 49.895 165.974 Z M 51.695 145.974 L 59.205 145.974 L 60.485 153.474 L 52.485 153.474 Z M 53.695 165.974 L 52.805 157.224 L 61.155 157.224 L 62.605 165.974 Z",
    style: {
      fill: "rgb(249, 250, 251)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerFlowChart);
export default __webpack_public_path__ + "static/media/power-flow-chart.931ec8c5.svg";
export { ForwardRef as ReactComponent };